var _dec, _dec2, _dec3, _dec4, _dec5, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _dec6, _dec7, _class2, _descriptor6, _descriptor7, _dec8, _dec9, _dec0, _dec1, _dec10, _dec11, _dec12, _class3, _class4, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _descriptor11;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import anyTrait from "../Decorators/anyTrait";
import objectArrayTrait from "../Decorators/objectArrayTrait";
import objectTrait from "../Decorators/objectTrait";
import primitiveTrait from "../Decorators/primitiveTrait";
import mixTraits from "../mixTraits";
import ModelTraits from "../ModelTraits";
import { traitClass } from "../Trait";
import CatalogMemberTraits from "./CatalogMemberTraits";
import GetCapabilitiesTraits from "./GetCapabilitiesTraits";
import ImageryProviderTraits from "./ImageryProviderTraits";
import LayerOrderingTraits from "./LayerOrderingTraits";
import LegendOwnerTraits from "./LegendOwnerTraits";
import LegendTraits from "./LegendTraits";
import MappableTraits from "./MappableTraits";
import UrlTraits from "./UrlTraits";
export let WebMapTileServiceAvailableStyleTraits = (_dec = primitiveTrait({
  type: "string",
  name: "Style Identifier",
  description: "The identifier of the style."
}), _dec2 = primitiveTrait({
  type: "string",
  name: "Title",
  description: "The title of the style."
}), _dec3 = primitiveTrait({
  type: "string",
  name: "Abstract",
  description: "The abstract describing the style."
}), _dec4 = objectTrait({
  type: LegendTraits,
  name: "Style Name",
  description: "The name of the style."
}), _dec5 = primitiveTrait({
  type: "string",
  name: "Is Default",
  description: "True if this Style is default; otherwise, false."
}), _class = class WebMapTileServiceAvailableStyleTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "identifier", _descriptor, this);
    _initializerDefineProperty(this, "title", _descriptor2, this);
    _initializerDefineProperty(this, "abstract", _descriptor3, this);
    _initializerDefineProperty(this, "legend", _descriptor4, this);
    _initializerDefineProperty(this, "isDefault", _descriptor5, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "identifier", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "title", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "abstract", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "legend", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "isDefault", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _class);
export let WebMapTileServiceAvailableLayerStylesTraits = (_dec6 = primitiveTrait({
  type: "string",
  name: "Layer Name",
  description: "The name of the layer for which styles are available."
}), _dec7 = objectArrayTrait({
  type: WebMapTileServiceAvailableStyleTraits,
  name: "Styles",
  description: "The styles available for this layer.",
  idProperty: "identifier"
}), _class2 = class WebMapTileServiceAvailableLayerStylesTraits extends ModelTraits {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "layerName", _descriptor6, this);
    _initializerDefineProperty(this, "styles", _descriptor7, this);
  }
}, _descriptor6 = _applyDecoratedDescriptor(_class2.prototype, "layerName", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class2.prototype, "styles", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class2);
let WebMapTileServiceCatalogItemTraits = (_dec8 = traitClass({
  description: "Creates a single item in the catalog from a url that points to a wmts service.",
  example: {
    type: "wmts",
    id: "a unique id for wmts example",
    name: "wmts example",
    url: "https://services.arcgisonline.com/arcgis/rest/services/Reference/World_Boundaries_and_Places/MapServer/WMTS/1.0.0/WMTSCapabilities.xml",
    layer: "Reference_World_Boundaries_and_Places",
    opacity: 1
  }
}), _dec9 = primitiveTrait({
  type: "string",
  name: "Is GeoServer",
  description: "True if this WMS is a GeoServer; otherwise, false."
}), _dec0 = primitiveTrait({
  type: "string",
  name: "Layer",
  description: "The layer to display."
}), _dec1 = primitiveTrait({
  type: "string",
  name: "Style",
  description: "The style to use with `Layer`."
}), _dec10 = objectArrayTrait({
  type: WebMapTileServiceAvailableLayerStylesTraits,
  name: "Available Styles",
  description: "The available styles.",
  idProperty: "layerName"
}), _dec11 = anyTrait({
  name: "Parameters",
  description: "Additional parameters to pass to the MapServer when requesting images."
}), _dec12 = primitiveTrait({
  type: "string",
  name: "Encoding",
  description: "The encoding of the tile images. We will try to load the tile images with this encoding, if not available we will fallback to KVP. Supported values are KVP and Restful"
}), _dec8(_class3 = (_class4 = class WebMapTileServiceCatalogItemTraits extends mixTraits(LayerOrderingTraits, GetCapabilitiesTraits, ImageryProviderTraits, UrlTraits, MappableTraits, CatalogMemberTraits, LegendOwnerTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "isGeoServer", _descriptor8, this);
    _initializerDefineProperty(this, "layer", _descriptor9, this);
    _initializerDefineProperty(this, "style", _descriptor0, this);
    _initializerDefineProperty(this, "availableStyles", _descriptor1, this);
    _initializerDefineProperty(this, "parameters", _descriptor10, this);
    _initializerDefineProperty(this, "requestEncoding", _descriptor11, this);
  }
}, _descriptor8 = _applyDecoratedDescriptor(_class4.prototype, "isGeoServer", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class4.prototype, "layer", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor0 = _applyDecoratedDescriptor(_class4.prototype, "style", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor1 = _applyDecoratedDescriptor(_class4.prototype, "availableStyles", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor10 = _applyDecoratedDescriptor(_class4.prototype, "parameters", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor11 = _applyDecoratedDescriptor(_class4.prototype, "requestEncoding", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "RESTful";
  }
}), _class4)) || _class3);
export { WebMapTileServiceCatalogItemTraits as default };